((Drupal, once) => {
  /**
   * Footer accordion behavior.
   */
  Drupal.behaviors.footerAccordion = {
    attach(context) {
      const footerLinks = context.querySelector('.footer-links');
      if (!footerLinks) return;

      const blocks = footerLinks.querySelectorAll('.block');
      const mobileBreakpoint = 768;

      const toggleAccordion = (event) => {
        // Only trigger if we are below the breakpoint.
        if (window.innerWidth >= mobileBreakpoint) {
          return;
        }

        const title = event.currentTarget;
        const block = title.closest('.block');

        if (block) {
          // Toggle current block
          const isActive = block.classList.toggle('is-active');
          title.setAttribute('aria-expanded', isActive);
        }
      };

      const handleKeydown = (event) => {
        // Only trigger if we are below the breakpoint.
        if (window.innerWidth >= mobileBreakpoint) {
          return;
        }

        // Trigger on Enter or Space
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          toggleAccordion(event);
        }
      };

      blocks.forEach((block) => {
        const title = block.querySelector('.block__title, h2');
        if (title) {
          // Use once() to ensure we only attach the listener once.
          once('footer-accordion', title, context).forEach((el) => {
            el.addEventListener('click', toggleAccordion);
            el.addEventListener('keydown', handleKeydown);

            // Add accessibility attributes for mobile
            if (window.innerWidth < mobileBreakpoint) {
              el.setAttribute('role', 'button');
              el.setAttribute('tabindex', '0');
              el.setAttribute('aria-expanded', 'false');

              // Find or create an ID for the content for aria-controls
              const content = block.querySelector('.block__content');
              if (content) {
                let contentId = content.id;
                if (!contentId) {
                  contentId = `footer-block-content-${Math.random().toString(36).substr(2, 9)}`;
                  content.id = contentId;
                }
                el.setAttribute('aria-controls', contentId);
              }
            }
          });
        }
      });
    },
  };
})(Drupal, once);
